import React, { useEffect, useState } from "react";
import Styles from "./NewEditorStyles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  sendQuestionDraftData,
  expertAnswerQuestion,
  fetchAttachmentURL,
} from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import TooltipComp from "../ToolTip/TooltipComp";
import DownloadAttachment from "./DownloadAttachment";
import AttachmentBox from "../../Component/AttachmentBox/AttachmentBox";
import { defaultPdfRules, transformForPdf } from "./NewEditorTextTranformer";

const getButtonStyle = (isDisabled) => ({
  padding: "8px 12px",
  borderRadius: "6px",
  fontSize: "14px",
  lineHeight: "24px",
  fontWeight: 400,
  boxShadow: "0px 1px 2px 0px #1018280D",
  color: "#FFFFFF",
  border: "1px solid #fff",
  height: "40px",
  minWidth: "88px",
  cursor: isDisabled ? "not-allowed" : "pointer",
  background: isDisabled
    ? "#A0A0A0"
    : "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
  marginBottom: "14px",
});

export default function NewEditorSubmitButtons({ isEdited, getEditorPayload }) {
  const editorState = useSelector((state) => state.editor);
  const userState = useSelector((state) => state.user);
  const answerePage = useSelector((state) => state.answeredQuestions);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const expertState = useSelector((state) => state.expertOpenData);
  const name = "answeredQuestions";
  let pageState = useSelector((state) => state[name]);
  const {
    changeCurationStatus,
    changeTransfered,
    IsLoadingAnsweredtab,
    updatePageNoAnswered,
    CheckEditAnswerBrief,
    advanceFilterModalToggle,
    getScrollPositionInExpertOpen,
    showNoShowConfetti,
    AnsweredPageBool,
    updateAttachmentForEditor,
    updatePageNumberExpertOpenTab,
    isBackClickedOnRecommend,
    updateRatingBoolean,
    recommendData,
    updateButtonEnableForEditor,
    ChangePublishButton,
  } = bindActionCreators(Actions, dispatch);
  // answeredQuestions
  // useEffect(()=>{

  // },[])
  // console.log("data",editorState.answerText)
  const sendDraftCall = () => {
    const patchedDraft = transformForPdf(
      editorState.answerText,
      defaultPdfRules
    );
    getScrollPositionInExpertOpen(0);
    setDisabled(true);
    let payload = {
      questionUuid: editorState.data.questionUuid,
      answer: patchedDraft,
      uploadFiles: editorState.attachments,
    };

    sendQuestionDraftData(payload).then((res) => {});
    setDisabled(false);
    updateRatingBoolean(true);
  };
  const submitAnswerSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  // const check = state?.roles
  //   ?.filter((item) => item.roleName === "Expert")
  //   .map((item) => {
  //     let val = item?.permissions;
  //     return val.find((perm) => perm.id === "4");
  //   });

  const isAnsweredByMe = (arr) => {
    let id = "";
    arr?.filter((obj) => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        id = obj.answerUuid;
      }
    });

    return id;
  };
  const isAnsweredByMeOrig = (arr) => {
    let id = "";
    arr?.filter((obj) => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        if (obj.origAnswerUuid !== undefined) {
          id = obj.origAnswerUuid;
        } else id = obj.answerUuid;
      }
    });

    return id;
  };
  const getExpertRequestUuuid = (arr, id) => {
    let val = arr.filter((item) => item.answerUuid === id);
    return val[0]?.expertRequestUuid;
  };

  const submitAnswer = () => {
    getScrollPositionInExpertOpen(null);
    setDisabled(true);
    ChangePublishButton(true);
    const fromEditor =
      typeof getEditorPayload === "function" ? getEditorPayload() : null;
    const rawHtml = fromEditor?.answerHtml ?? editorState.answerText;
    const safeFiles = fromEditor?.uploadFiles ?? editorState.attachments;
    const answerDelta = fromEditor?.answerDelta;
    const patchedHtml = transformForPdf(rawHtml, defaultPdfRules);

    if (editorState.submissionType === "answer") {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      const finalHtml = patchedHtml;

      let payload = {
        questionUuidStr: editorState.data.questionUuid,
        answer: finalHtml,
        uplodedFiles: safeFiles,
        answerDelta,
        internal: editorState.internalOnly,
        privacy: editorState.isVizKnowledgeBase,
        expiration: Date.parse(editorState.expirationDate),
        question:
          editorState.data.otherLanguageQuestionText == null
            ? editorState.questionText
            : editorState.data.otherLanguageQuestionText,
      };
      if (
        editorState.data.expertRequestUuid !== undefined &&
        editorState.ownRecords
      ) {
        delete payload.questionUuidStr;
        payload.expertRequestUuid = editorState.data.expertRequestUuid;
      }
      updateButtonEnableForEditor(true);
      expertAnswerQuestion(payload, false).then((res) => {
        if (res === undefined) return;
        showNoShowConfetti(true);
        getScrollPositionInExpertOpen(expertState.getScrollPosition);
        // getScrollPositionInExpertOpen(0)
        setTimeout(() => {
          showNoShowConfetti(false);
        }, 5000);
        setDisabled(false);
        ChangePublishButton(false);
        // ChangePublishButton(false)
        updatePageNumberExpertOpenTab(0);
        toast.success(
          submitAnswerSuccessToast(
            "Thanks for answering!\nYou will be notified when your answer is rated."
          ),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        //      isBackClickedOnRecommend(true);
        //  setTimeout(() => {
        //    resetStateForEditor();
        //    isBackClickedOnRecommend(false);
        //  }, 3000);
        recommendData(null);
        navigate(-1);
      });
    } else {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      const finalHtml = patchedHtml;

      let payloadForUpdation = {
        questionText: editorState.questionText,
        domain: editorState.data.domain,
        postedDate: editorState.data.questionPostedTimestamp,
        questionUuid: editorState.data.questionUuid,
        answerUuid:
          isAnsweredByMe(
            editorState.data.answers !== undefined
              ? editorState.data.answers
              : editorState.data.answersList
          ) ===
          isAnsweredByMeOrig(
            editorState.data.answers !== undefined
              ? editorState.data.answers
              : editorState.data.answersList
          )
            ? isAnsweredByMe(
                editorState.data.answers !== undefined
                  ? editorState.data.answers
                  : editorState.data.answersList
              )
            : isAnsweredByMeOrig(
                editorState.data.answers !== undefined
                  ? editorState.data.answers
                  : editorState.data.answersList
              ),
        answerText: finalHtml,
        answerDelta: answerDelta,
        expertUUID: userState.geoAttributes.userId,
        expertRequestUuid:
          editorState.data.expertRequestUuid === undefined
            ? ""
            : editorState.data.expertRequestUuid,
        // expertRequestUuid:getExpertRequestUuuid(editorState.data.answers!==undefined?editorState.data.answers:editorState.data.answersList,
        //   isAnsweredByMe(editorState.data.answers!==undefined?editorState.data.answers:editorState.data.answersList) === isAnsweredByMeOrig(editorState.data.answers!==undefined?editorState.data.answers:editorState.data.answersList)?isAnsweredByMe(editorState.data.answers!==undefined?editorState.data.answers:editorState.data.answersList):isAnsweredByMeOrig(editorState.data.answers!==undefined?editorState.data.answers:editorState.data.answersList)
        // ),
        expertAnswerRequest: {
          uplodedFiles: safeFiles,
        },
        expiration: Date.parse(editorState.expirationDate),
        privacy: editorState.isVizKnowledgeBase,
        internal: editorState.internalOnly,
      };
      expertAnswerQuestion(payloadForUpdation, true).then((res) => {
        setDisabled(false);
        ChangePublishButton(false);
        // ChangePublishButton(false)
        if (res === undefined) return;
        showNoShowConfetti(true);
        updateRatingBoolean(true);
        getScrollPositionInExpertOpen(expertState.getScrollPosition);
        // getScrollPositionInExpertOpen(null)

        setTimeout(() => {
          showNoShowConfetti(false);
        }, 5000);
        updatePageNumberExpertOpenTab(0);
        toast.success(
          submitAnswerSuccessToast(
            "Thanks for answering!\nYou will be notified when your answer is rated."
          ),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        //    isBackClickedOnRecommend(true);
        //  setTimeout(() => {
        //   resetStateForEditor();
        //    isBackClickedOnRecommend(false);
        //  }, 3000);
        IsLoadingAnsweredtab(true);
        navigate(-1);

        if (editorState.pageNumber !== 0) {
          // console.log("answered", editorState.answeredBoolean)
          updateRatingBoolean(true);
          updatePageNoAnswered(editorState.pageNumber);
          AnsweredPageBool(editorState.answeredBoolean);
        } else {
          updateRatingBoolean(true);
          AnsweredPageBool(!editorState.answeredBoolean);
        }
        changeCurationStatus(pageState.curationStatus);
        changeTransfered(pageState.isTransfered);
        //  updateRatingBoolean(true)
      });
    }
    getScrollPositionInExpertOpen(expertState.getScrollPosition);
    getScrollPositionInExpertOpen(null);
  };

  const removeAttachment = (data) => {
    let newData = editorState.attachments.filter((att) => {
      if (att.name !== data.name) {
        return att;
      }
    });
    updateAttachmentForEditor(newData);
  };
  const buttonEdit = () => {
    let pureStr = editorState?.answerText?.replace(/<[^>]*>?/gm, "");
    if (
      pureStr?.length > 0 &&
      editorState?.questionText?.length > 0 &&
      !disabled
    ) {
      return false;
    } else {
      return true;
    }
  };
  const openPreviewAttachment = (file) => {
    // if(editorState.compareAttachments)

    // console.log("file name",file)
    let payload = {
      name: file,
    };
    fetchAttachmentURL(payload)
      .then((res) => {
        if (res === undefined) return;
        var response = res.data.data;
        if (
          (file?.includes(".pdf") ||
            file?.includes(".PDF") ||
            file?.includes(".Pdf")) &&
          !file?.includes(".pdf_")
        ) {
          response.src = response.src.replace(
            "data:null",
            "data:application/pdf"
          );
        } else {
          response.src = response.src.replace("data:null", "data:image/png");
        }
        fetch(response.src).then(function (res1) {
          res1.blob().then(function (blob) {
            window.open(URL.createObjectURL(blob), "_blank");
          });
        });
      })
      .catch((err) => {});
  };

  const onclickPublic = () => {
    getScrollPositionInExpertOpen(0);
    CheckEditAnswerBrief(isEdited);
    ChangePublishButton(true);
    advanceFilterModalToggle({ bool: true, value: "breifingModal" });
  };
  // editorState?.data?.published||buttonEdit()||editorState?.publishButtonBool

  // console.log("button", editorState?.data?.published, buttonEdit(), editorState?.publishButtonBool)
  return (
    <>
      <div style={{ paddingTop: "5px" }}>
        <div style={{ width: "75%" }}>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {editorState.attachments &&
              editorState.attachments.map((attchmnt) => {
                return (
                  <div className={Styles.attachmentsName}>
                    <TooltipComp
                      title={`${
                        attchmnt.caption !== undefined
                          ? attchmnt.caption
                          : attchmnt.name
                      }`}
                    >
                      {
                        // attchmnt.name
                        // console.log("name",attchmnt.name)
                        // editorState.compareAttachments.includes(attchmnt.name) ?<span>yess</span>:null
                      }
                      {(attchmnt?.name?.includes(".pdf") ||
                        attchmnt?.name?.includes(".PDF") ||
                        attchmnt?.name?.includes(".Pdf")) &&
                      !attchmnt?.name?.includes(".pdf_") ? (
                        <span
                          style={{ cursor: "pointer" }}
                          className={Styles.onPreview}
                        >
                          <span
                            className={Styles.onPreview}
                            style={{
                              cursor:
                                editorState.compareAttachments.some(
                                  (item) => item.name === attchmnt.name
                                ) && "auto",
                              textDecoration:
                                editorState.compareAttachments.some(
                                  (item) => item.name === attchmnt.name
                                ) && "none",
                            }}
                            onClick={() =>
                              !editorState.compareAttachments.some(
                                (item) => item.name === attchmnt.name
                              ) &&
                              editorState.attachments.some(
                                (item) => item.name === attchmnt.name
                              ) &&
                              openPreviewAttachment(attchmnt.name)
                            }
                          >
                            {attchmnt.name}
                          </span>
                          {!editorState.compareAttachments.some(
                            (item) => item.name === attchmnt.name
                          ) && <DownloadAttachment attachment={attchmnt} />}
                        </span>
                      ) : attchmnt.name?.includes(".jpeg") ||
                        attchmnt.name?.includes(".jpg") ||
                        attchmnt.name?.includes(".png") ||
                        attchmnt.name?.includes(".JPEG") ||
                        attchmnt.name?.includes(".JPG") ||
                        attchmnt.name?.includes(".PNG") ? (
                        <span>
                          <span
                            style={{
                              cursor:
                                !editorState.compareAttachments.some(
                                  (item) => item.name === attchmnt.name
                                ) &&
                                editorState.attachments.some(
                                  (item) => item.name === attchmnt.name
                                )
                                  ? "pointer"
                                  : "auto",
                            }}
                            className={
                              !editorState.compareAttachments.some(
                                (item) => item.name === attchmnt.name
                              ) &&
                              editorState.attachments.some(
                                (item) => item.name === attchmnt.name
                              ) &&
                              Styles.onPreview
                            }
                          >
                            <span
                              className={
                                !editorState.compareAttachments.some(
                                  (item) => item.name === attchmnt.name
                                ) && Styles.onPreview
                              }
                              onClick={() =>
                                !editorState.compareAttachments.some(
                                  (item) => item.name === attchmnt.name
                                ) &&
                                editorState.attachments.some(
                                  (item) => item.name === attchmnt.name
                                ) &&
                                openPreviewAttachment(attchmnt.name)
                              }
                            >
                              {attchmnt.name}
                            </span>
                            {!editorState.compareAttachments.some(
                              (item) => item.name === attchmnt.name
                            ) &&
                              editorState.attachments.some(
                                (item) => item.name === attchmnt.name
                              ) && <DownloadAttachment attachment={attchmnt} />}
                          </span>
                        </span>
                      ) : attchmnt.name?.includes(".docx") ||
                        attchmnt.name?.includes(".doc") ||
                        attchmnt.name?.includes(".xlsx") ||
                        attchmnt.name?.includes(".ppt") ||
                        attchmnt.name.includes(".csv") ? (
                        <span style={{ cursor: "auto" }}>
                          <span>{attchmnt.name}</span>
                          {!editorState.compareAttachments.some(
                            (item) => item.name === attchmnt.name
                          ) &&
                            editorState.attachments.some(
                              (item) => item.name === attchmnt.name
                            ) && <DownloadAttachment attachment={attchmnt} />}
                        </span>
                      ) : (
                        <span>
                          <span
                            className={
                              !editorState.compareAttachments.some(
                                (item) => item.name === attchmnt.name
                              ) &&
                              editorState.attachments.some(
                                (item) => item.name === attchmnt.name
                              ) &&
                              Styles.onPreview
                            }
                          >
                            {attchmnt.name}
                          </span>
                          {!editorState.compareAttachments.some(
                            (item) => item.name === attchmnt.name
                          ) &&
                            editorState.attachments.some(
                              (item) => item.name === attchmnt.name
                            ) && <DownloadAttachment attachment={attchmnt} />}
                        </span>
                      )}
                      <span>
                        &nbsp;
                        <i
                          className="fa fa-close"
                          style={{
                            cursor: "pointer",
                            color: "var(--light_color_shade)",
                          }}
                          onClick={() => removeAttachment(attchmnt)}
                        ></i>
                      </span>
                    </TooltipComp>
                  </div>
                );
              })}

            {/* {data.attachments !== undefined &&
                            data.attachments.length > 0 &&
                            data.attachments.map((attch) => {
                              return <AttachmentBox attachment={attch} />;
                            })} */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "0.6em",
            paddingTop: "6px",
          }}
        >
          <button
            onClick={() => sendDraftCall()}
            style={{
              padding: "8px 12px 8px 12px",
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "24px",
              fontWeight: 400,
              boxShadow: " 0px 1px 2px 0px #1018280D",
              color: "#2A364A",
              border: "1px solid  #fff",
              height: "40px",
              minWidth: "88px",
              background: " #F6F7F8",
              marginBottom: "14px",
              fontWeight: 400,
              border: " 1px solid #E0E2E6",
              cursor:
                disabled || editorState?.publishButtonBool
                  ? "not-allowed"
                  : "pointer",
              //  font-weight: 400;
            }}
            // disabled={disabled}
            disabled={disabled || editorState?.publishButtonBool}
            // className="buttonDark"
          >
            <i className="fa fa-save"></i>&nbsp;Save Draft
          </button>

          {/* <button  disabled={editorState.isButtonEnable}  onClick={()=>sendDraftCall()} className='btn btn-primary videoshowbuttonAB' style={{fontSize:'.9rem' }}><i className='fa fa-save'></i>&nbsp;Save Draft</button>&nbsp; */}
          <button
            style={getButtonStyle(
              buttonEdit() || editorState?.publishButtonBool
            )}
            disabled={buttonEdit() || editorState?.publishButtonBool}
            onClick={submitAnswer}
          >
            <i className="fa fa-send"></i>&nbsp;Submit
          </button>

          {editorState?.data?.agenticId !== undefined && (
            <button
              style={getButtonStyle(
                buttonEdit() ||
                  editorState?.data?.published ||
                  editorState?.publishButtonBool
              )}
              disabled={
                editorState?.data?.published ||
                buttonEdit() ||
                editorState?.publishButtonBool
              }
              onClick={onclickPublic}
            >
              <i className="fa fa-user"></i>&nbsp;Publish
            </button>
          )}
          {/* buttonEdit()||editorState?.data?.published||editorState?.publishButtonBool? */}

          {/* <button  onClick={()=>submitAnswer()} className='btn btn-primary videoshowbuttonAB'   style={{fontSize:'.9rem', }}
        disabled={editorState.isButtonEnable}><i className='fa fa-send'></i>&nbsp;Submit</button> */}
        </div>
      </div>
    </>
  );
}

// questionText
